import Vue from 'vue';

import Header from '@components/header/script.js';
import Footer from '@components/footer/script.js';
import About from '@components/about-main-page/script.js';
import Button from '@components/ui/button.vue';
import SalesGrid from '@components/sales-item/script.js';
import { mapState } from 'vuex';

let PageComponent = {
  name: 'index',
  data() {
    return {
      template: '<p>default temp</p>',
    };
  },
  components: {
    'header-cmp': Header,
    'cmp-footer': Footer,
    'cmp-about-main-page': About,
    't-button': Button,
    'sales-cmp': SalesGrid,
  },
  methods: {
    setTemplate: function(template) {
      this.template = template.data;
    },
    setData: function(data, to) {
      this.setTemplate(data);
    },
  },
  computed: {
    leftMenuVisible: function() {
      return window.innerWidth < 1280;
    },
    ...mapState('params', ['mobile']),
  },
  mounted() {
    if (!this.mobile) {
      setTimeout(() => {
        var myWave = wavify(document.querySelector('#main-page-wave'), {
          height: 25,
          bones: 4,
          amplitude: 50,
          color: '#F5F7FA',
          speed: 0.15,
        });
      }, 100);
    }
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeRouteEnter(to, from, next) {
    let pageContent = document.getElementById('index');
    if (pageContent) {
      next((vm) => (vm.template = pageContent.innerHTML));
      pageContent.remove();
    } else {
      let url = '/api/templates';
      Vue.http.get(url, { params: to.query }).then(
        (data) => {
          next((vm) => vm.setData(data));
        },
        () => {
          next('/404');
        }
      );
    }
  },
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement);
  },
};
export default PageComponent;



// WEBPACK FOOTER //
// ./src/templates/pages/index.js